import type { ReactNode } from 'react';

interface ColumnsVisibilityTabsProps {
  tabsSlot?: ReactNode;
}

const ColumnsVisibilityTabs = ({ tabsSlot }: ColumnsVisibilityTabsProps) => tabsSlot ?? null;

export default ColumnsVisibilityTabs;
